import * as sterlingparker from './Segmented.styles.sterlingparker';
import * as betprofessor from './Segmented.styles.betprofessor';
import * as volcanobet from './Segmented.styles.volcanobet';
import * as puntgenie from './Segmented.styles.puntgenie';
import * as junglebet from './Segmented.styles.junglebet';
import * as fiestabet from './Segmented.styles.fiestabet';
import * as puntcity from './Segmented.styles.puntcity';
import * as betgalaxy from './Segmented.styles.betgalaxy';
import * as betroyale from './Segmented.styles.betroyale';
import * as juicybet from './Segmented.styles.juicybet';
import * as goldenrush from './Segmented.styles.goldenrush';
import * as vikingbet from './Segmented.styles.vikingbet';
import * as questbet from './Segmented.styles.questbet';
import * as wellbet from './Segmented.styles.wellbet';
import * as sugarcastle from './Segmented.styles.sugarcastle';
import * as oldgill from './Segmented.styles.oldgill';
import * as buffalobet from './Segmented.styles.buffalobet';
import * as titanbet from './Segmented.styles.titanbet';
import * as gigabet from './Segmented.styles.gigabet';
import * as slambet from './Segmented.styles.slambet';
import * as betstride from './Segmented.styles.betstride';
import * as templebet from './Segmented.styles.templebet';
import * as goldenbet888 from './Segmented.styles.goldenbet888';
import * as hyperbet from './Segmented.styles.hyperbet';
import * as bet777 from './Segmented.styles.bet777';
import * as chromabet from './Segmented.styles.chromabet';
import * as bet575 from './Segmented.styles.bet575';
import * as betblast from './Segmented.styles.betblast';
import * as pyramidbet from './Segmented.styles.pyramidbet';
import * as magnumbet from './Segmented.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  betprofessor,
  volcanobet,
  puntgenie,
  junglebet,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
